var map = {
	"./AZ Alkmaar.png": 6770,
	"./Ajax.png": 2116,
	"./Anderlecht.png": 3004,
	"./Arsenal.png": 4214,
	"./Aston Villa.png": 6143,
	"./Atalanta.png": 6062,
	"./Athletic Bilbao.png": 2633,
	"./Atlético de Madrid.png": 7935,
	"./Barcelona.png": 5063,
	"./Bayer Leverkusen.png": 2639,
	"./Bayern München.png": 1036,
	"./Benfica.png": 9968,
	"./Bodo Glimt.png": 1297,
	"./Borussia Dortmund.png": 7363,
	"./Brest.png": 5036,
	"./Celtic.png": 7450,
	"./Club Brugge.png": 7668,
	"./Eintracht Frankfurt.png": 6431,
	"./FC Porto.png": 4139,
	"./FC Twente.png": 2036,
	"./Fenerbahçe.png": 4701,
	"./Ferencváros.png": 1086,
	"./Feyenoord.png": 9617,
	"./Galatasaray.png": 3496,
	"./Internazionale.png": 2085,
	"./Juventus.png": 2388,
	"./Lazio.png": 2645,
	"./Lille.png": 1842,
	"./Liverpool.png": 6846,
	"./Lyon.png": 5052,
	"./Manchester City.png": 6047,
	"./Manchester United.png": 8035,
	"./Midtjylland.png": 8832,
	"./Milan.png": 2415,
	"./Monaco.png": 4355,
	"./Olympiacos.png": 774,
	"./PAOK.png": 189,
	"./PSV.png": 9963,
	"./Paris SG.png": 2307,
	"./Plzen.png": 7731,
	"./Rangers.png": 2302,
	"./Real Madrid.png": 8739,
	"./Real Sociedad.png": 322,
	"./Roma.png": 8617,
	"./Sporting.png": 8844,
	"./Steaua Bucareste.png": 7729,
	"./TBD.png": 754,
	"./TacaPalpitesLigaCampeoesEuropa2025.png": 9396,
	"./Tottenham.png": 3124,
	"./Union St. Gilloise.png": 5346,
	"./champions_icon.png": 4686,
	"./europa_icon.png": 7798
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5025;